export const profileConstants = {
  
  GETPROFILE_REQUEST: 'GETPROFILE_REQUEST',
  GETPROFILE_SUCCESS: 'GETPROFILE_SUCCESS',
  GETPROFILE_FAILURE: 'GETPROFILE_FAILURE',
  
};
